import React, { Component } from 'react'
import { connect } from 'react-redux'
import Sticky from 'react-stickynode'

// Components
import HeaderBar from './header/HeaderBar'
import LogoSection from './header/LogoSection'
import MainNav from './header/MainNav'

class Header extends Component {
	render() {
		return (
			<header>
				<HeaderBar />
				<LogoSection />
				<Sticky innerZ={10}>
					<MainNav />
				</Sticky>
			</header>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		cart: state.cart
	}
}

export default connect(mapStateToProps)(Header)



// WEBPACK FOOTER //
// ./src/components/Header.js